import { render, staticRenderFns } from "./docmanageview.vue?vue&type=template&id=38fd1008&scoped=true&"
import script from "./docmanageview.vue?vue&type=script&lang=js&"
export * from "./docmanageview.vue?vue&type=script&lang=js&"
import style0 from "./docmanageview.vue?vue&type=style&index=0&id=38fd1008&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd1008",
  null
  
)

export default component.exports